var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mobilier-form",
      on: {
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          return _vm.$emit("submitForm")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "grid" },
        [
          _vm._l(_vm.formData.regions, function (group) {
            return _c(
              "div",
              { staticClass: "grid__row" },
              [
                group.label
                  ? _c(
                      "p",
                      { staticClass: "headline-medium black mg mg--b-2" },
                      [_vm._v(_vm._s(group.label))]
                    )
                  : _vm._e(),
                _vm._t("inputForms", function () {
                  return [
                    _vm._l(group.inputs, function (input) {
                      return [
                        input.type === "text" &&
                        input.self_care_hidden === false
                          ? _c("ma-input-text", {
                              attrs: {
                                type: "text",
                                name: input.name,
                                col: input.col,
                                icon: input.icon,
                                literal: input.literal,
                                value: input.selectedValue,
                                disabled: input.disabled,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleEvent(
                                    "change",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                                input: function ($event) {
                                  return _vm.handleEvent(
                                    "input",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                        input.type === "textNumbers" &&
                        input.self_care_hidden === false
                          ? _c("ma-input-text-numbers", {
                              attrs: {
                                type: "text",
                                name: input.name,
                                col: input.col,
                                icon: input.icon,
                                literal: input.literal,
                                value: input.selectedValue,
                                disabled: input.disabled,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleEventTextNumber(
                                    "change",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments,
                                    "textNumbers"
                                  )
                                },
                                input: function ($event) {
                                  return _vm.handleEventTextNumber(
                                    "input",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments,
                                    "textNumbers"
                                  )
                                },
                              },
                            })
                          : input.type === "hidden" &&
                            input.self_care_hidden === false
                          ? _c("ma-input-text", {
                              attrs: {
                                type: "text",
                                hidden: true,
                                name: input.name,
                                col: input.col,
                                icon: input.icon,
                                literal: input.literal,
                                agentLiteral: input.agent_literal,
                                value: input.selectedValue,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleEvent(
                                    "change",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                                input: function ($event) {
                                  return _vm.handleEvent(
                                    "input",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                              },
                            })
                          : input.type === "select" &&
                            input.options.length > 10 &&
                            input.self_care_hidden === false
                          ? _c("ma-input-select", {
                              attrs: {
                                type: "select",
                                name: input.name,
                                col: input.col,
                                icon: input.icon,
                                literal: input.literal,
                                options: input.options,
                                value: input.selectedValue,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleEvent(
                                    "change",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                                input: function ($event) {
                                  return _vm.handleEvent(
                                    "input",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                              },
                            })
                          : input.type === "select" &&
                            _vm.agentView === true &&
                            input.self_care_hidden === false
                          ? _c("ma-input-btn", {
                              attrs: {
                                type: "radio",
                                name: input.name,
                                col: input.col,
                                icon: input.icon,
                                literal: input.literal,
                                agentLiteral: input.agent_literal,
                                options: input.options,
                                value: input.selectedValue,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleEvent(
                                    "change",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                                input: function ($event) {
                                  return _vm.handleEvent(
                                    "input",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                              },
                            })
                          : input.type === "radio" &&
                            _vm.agentView === false &&
                            input.self_care_hidden === false
                          ? _c("ma-input-radio", {
                              attrs: {
                                type: "radio",
                                name: input.name,
                                col: input.col,
                                icon: input.icon,
                                literal: input.literal,
                                options: input.options,
                                value: input.selectedValue,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleEvent(
                                    "change",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                                input: function ($event) {
                                  return _vm.handleEvent(
                                    "input",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                              },
                            })
                          : input.type === "radio" &&
                            _vm.agentView === true &&
                            input.self_care_hidden === false
                          ? _c("ma-input-btn", {
                              attrs: {
                                type: "radio",
                                name: input.name,
                                col: input.col,
                                icon: input.icon,
                                literal: input.literal,
                                options: input.options,
                                value: input.selectedValue,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleEvent(
                                    "change",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                                input: function ($event) {
                                  return _vm.handleEvent(
                                    "input",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                              },
                            })
                          : input.type === "checkbox" &&
                            _vm.agentView === false &&
                            input.self_care_hidden === false
                          ? _c("ma-input-checkbox", {
                              attrs: {
                                type: "checkbox",
                                name: input.name,
                                col: input.col,
                                literal: input.literal,
                                options: input.options,
                                value: input.selectedValue,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleEvent(
                                    "change",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                                input: function ($event) {
                                  return _vm.handleEvent(
                                    "input",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                              },
                            })
                          : input.type === "checkbox" &&
                            _vm.agentView === true &&
                            input.self_care_hidden === false
                          ? _c("ma-input-btn", {
                              attrs: {
                                type: "checkbox",
                                name: input.name,
                                col: input.col,
                                literal: input.literal,
                                options: input.options,
                                value: input.selectedValue,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleEvent(
                                    "change",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                                input: function ($event) {
                                  return _vm.handleEvent(
                                    "input",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                              },
                            })
                          : input.type === "textmap" &&
                            input.self_care_hidden === false
                          ? _c("ma-input-textmap", {
                              attrs: {
                                type: "textmap",
                                name: input.name,
                                col: input.col,
                                literal: input.literal,
                                value: input.selectedValue,
                                coordinates: _vm.stateWarrantyCoordinates,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleEventTextNumber(
                                    "change",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments,
                                    "textNumbers"
                                  )
                                },
                                input: function ($event) {
                                  return _vm.handleEventTextNumber(
                                    "input",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments,
                                    "textNumbers"
                                  )
                                },
                              },
                            })
                          : input.type === "textmapline" &&
                            input.self_care_hidden === false
                          ? _c("ma-input-textmapline", {
                              attrs: {
                                type: "textmapline",
                                name: input.name,
                                col: input.col,
                                literal: input.literal,
                                value: input.selectedValue,
                                coordinates: _vm.stateWarrantyCoordinates,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleEventTextNumber(
                                    "change",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments,
                                    "textNumbers"
                                  )
                                },
                                input: function ($event) {
                                  return _vm.handleEventTextNumber(
                                    "input",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments,
                                    "textNumbers"
                                  )
                                },
                              },
                            })
                          : input.type === "imgRadio" &&
                            input.self_care_hidden === false
                          ? _c("ma-input-imgradio", {
                              attrs: {
                                type: "imgRadio",
                                name: input.name,
                                col: input.col,
                                literal: input.literal,
                                options: input.options,
                                value: input.selectedValue,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleEvent(
                                    "change",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                                input: function ($event) {
                                  return _vm.handleEvent(
                                    "change",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                              },
                            })
                          : input.type === "selectmapline" &&
                            input.self_care_hidden === false
                          ? _c("ma-input-select-map", {
                              attrs: {
                                type: "select",
                                name: input.name,
                                col: input.col,
                                icon: input.icon,
                                literal: input.literal,
                                options: input.options,
                                value: input.selectedValue,
                                coordinates: _vm.stateWarrantyCoordinates,
                                measure: "line",
                                viewer: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleEvent(
                                    "change",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                              },
                            })
                          : input.type === "selectmap" &&
                            input.self_care_hidden === false
                          ? _c("ma-input-select-map", {
                              attrs: {
                                type: "select",
                                name: input.name,
                                col: input.col,
                                icon: input.icon,
                                literal: input.literal,
                                options: input.options,
                                value: input.selectedValue,
                                coordinates: _vm.stateWarrantyCoordinates,
                                measure: "surface",
                                viewer: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleEvent(
                                    "change",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                                input: function ($event) {
                                  return _vm.handleEvent(
                                    "input",
                                    input.hasNestedComponents,
                                    input.name,
                                    ...arguments
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    }),
                  ]
                }),
              ],
              2
            )
          }),
          _c(
            "div",
            { staticClass: "grid__cell-md-4" },
            [
              _c("ma-input-file", {
                attrs: {
                  titleInput: _vm.titleFileInputPres,
                  name: _vm.nameFileInputPres,
                  imageList: _vm.inputImgListPres,
                },
                on: {
                  "file:src": function ($event) {
                    return _vm.handleFileChangeImgPres(...arguments)
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }